const Resources = {

    table_headers: [
        { 
            text:   'Associate',
            value:  'associate'
        },
        {   
            text:   'Assignment',
            value:  'assignment'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Days Off',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Live Schedules',
            href:   '/days-off-schedules',
            arrow:  "",
        },
    ],

    excel_file_headers: {
        'Assignment Number': 'Assignment Number',
    },

    empty_format_data: [
        {
            'Assignment Number': '',
        }
    ],

    helps: [
        {
            label: '¿How to create a Live Schedule?', 
            instruction: `https://scribehow.com/embed/How_to_Create_a_Live_Schedule__GvpJLgfqRLibJ_mAsU2mDA?as=scrollable`
        },
        {
            label: 'How to apply a Master Days Off in Live Schedules?', 
            instruction: `https://scribehow.com/embed/How_to_Apply_a_Master_Days_Off_in_Live_Schedules__GvpJLgfqRLibJ_mAsU2mDA?as=scrollable`
        },
    ],

}

export default Resources;